/**
 * Module đang chạy trong tenant của người đăng nhập (`module-registry`, nhóm route tenant của
 * ADR-0007), cho menu và host Module Federation của cổng tenant (ADR-0096).
 */
import { dungApiThat, goiApi } from '../api/http';
import { mockRequest } from '../../mock/transport';
import { danhSachModuleDaCaiGia } from '../../mock/module-da-cai';
import type { InstalledModule, InstalledModuleList } from '../../modules/module-da-cai/types';

export const moduleDaCaiRepository = {
  /** `GET /api/v1/modules/installed` — không phân trang: số dòng không vượt danh mục module của nền tảng (vài chục). */
  danhSach: (): Promise<InstalledModule[]> =>
    dungApiThat()
      ? goiApi<InstalledModuleList>('/api/v1/modules/installed').then((kq) => kq.items)
      : mockRequest(danhSachModuleDaCaiGia(), []),
};
